// ----------------------------------------------------------------------

export const boolean = [
  true,
  true,
  true,
  false,
  false,
];
